.line {
  display: block;
  width: 100%;
  height: 0.875rem;
  border-radius: var(--radius-sm);
  background-color: var(--color-surface-2);
  animation: pulse 1.2s ease-in-out infinite;
}

.thin {
  height: 0.625rem;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-6);
}

/* For screen readers only; the grey rows are hidden from them. */
.label {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.row {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.circle {
  flex-shrink: 0;
  width: var(--control-height-sm);
  height: var(--control-height-sm);
  border-radius: var(--radius-full);
  background-color: var(--color-surface-2);
  animation: pulse 1.2s ease-in-out infinite;
}

.text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

@keyframes pulse {
  50% {
    opacity: 0.45;
  }
}
